import { Box, Button, Dialog, List, ListItem, ListItemText, Radio, TextField } from "@material-ui/core";
import FormBlock from "components/Form/FormBlock";
import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "store/hooks";
import { OfferingPoolResponseType, selectCurrentTempleOfferingPools } from "store/reducers/temple/offeringPoolSlice";
import AddOfferingPool from "../OfferingPool/AddOfferingPool";

type Props = {
    pools: string[],
    setPools: (pools: string[]) => void
}

export default function PoolSelect({ pools, setPools }: Props) {
    const allPools = useAppSelector(selectCurrentTempleOfferingPools)
    const [search, setSearch] = useState("")

    // Filter and sort pools based on search input and assignment
    const filteredPools = useMemo(() => {
        let result = allPools;
        if (search) {
            result = allPools.filter(d =>
                d.poolName.toLowerCase().includes(search.toLowerCase())
            )
        }
        return [...result].sort((a, b) => {
            const isASelected = pools.includes(a.url);
            const isBSelected = pools.includes(b.url);
            if (isASelected && !isBSelected) return -1;
            if (!isASelected && isBSelected) return 1;
            return 0;
        });
    }, [search, allPools, pools])

    const [open, setOpen] = useState(false)
    const [showPools, setShowPools] = useState(false)

    useEffect(() => {
        if (pools.length > 1) {
            setPools([pools[0]])
        }
    }, [pools, setPools])

    const handlePoolCreated = (pool: OfferingPoolResponseType) => {
        setPools([pool.url])
        setShowPools(true)
    }

    const handlePoolToggle = (poolUrl: string) => {
        setPools(pools.includes(poolUrl) ? [] : [poolUrl])
    }

    return (
        <>
            <FormBlock titleId={'offeringPool.title'} action={<Button size="small" onClick={() => {setShowPools(!showPools)}} variant="outlined">{showPools ?  "Close" :"Open"}</Button>}>
                <Box mb={2} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="Search pools..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <Button onClick={() => setOpen(true)} style={{ width: 'fit-content', whiteSpace: 'nowrap' }} variant="outlined" color="primary">Create New</Button>
                </Box>

              {(showPools || search) &&   <Box style={{ maxHeight: 600, overflowY: 'scroll' }}>
                    <List disablePadding dense >
                        {filteredPools.map(d => (
                            <ListItem button onClick={() => handlePoolToggle(d.url)} disableGutters key={d.url}>
                                <Radio checked={pools.indexOf(d.url) > -1} size="small" />
                                <ListItemText primaryTypographyProps={{ style: { fontSize: 14 } }} primary={`${d.poolName}`} />
                            </ListItem>
                        ))}
                    </List>
                </Box>}

            </FormBlock>
            {
                open && <Dialog onClose={() => setOpen(false)} open>
                    <AddOfferingPool
                        onClose={() => setOpen(false)}
                        onCreated={handlePoolCreated}
                    />
                </Dialog>
            }
        </>
    )
}
